<template>
  <SideBlock class="QuickOfferBox" :title="$t('quickOfferBox.title')">
    <p class="sideBlockText">
      {{ $t("quickOfferBox.titleParagraph") }}
    </p>
    <TenderSteps class="offerSteps mb-5" />

    <div v-if="textInput" class="tender-text">
      <p class="mb-1">{{ $t("quickOfferBox.inputLabel") }}</p>
      <textarea
        v-model="tenderText"
        class="textarea"
        :placeholder="$t('quickOfferBox.placeholder')"
        type="text"
      />
    </div>

    <div class="sideBlockCtas">
      <JoszakiButton type="info" expanded @click="requestTender()">
        {{ $t("quickOfferBox.submit") }}
      </JoszakiButton>
    </div>
  </SideBlock>
</template>

<script>
import TenderSteps from "~/components/_refactored/img/TenderSteps.vue";
import SideBlock from "~/components/_refactored/mainpage/SideBlock.vue";
import { EVENT_REQUEST_TENDER } from "~/composables/requestTender";

export default {
  components: { SideBlock, TenderSteps },
  props: {
    isBlog: {
      type: Boolean,
      default: false,
    },
    textInput: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tenderText: "",
    };
  },
  methods: {
    requestTender() {
      this.$track.analyticsEvent({
        category: "gyorsitott",
        action: "kattintas-ajanlatkeresre",
      });

      this.$track.analyticsEvent({
        category: "quick-tender",
        action: "click",
      });

      this.$mitt.emit(EVENT_REQUEST_TENDER, {
        source: "quickOffer",
        description: this.tenderText,
      });
      this.$emit("requestTender", this.tenderText);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "styles/_all-members" as global;

.QuickOfferBox {
  .offerSteps {
    max-height: 80px;
    margin: 0px auto;
  }

  .tender-text {
    color: global.$blogTextColor;
    display: flex;
    flex-direction: column;
    width: 100%;
    text-align: center;

    .textarea {
      width: 100%;
      height: 80px;
      min-height: 20px;
      background: rgba(white, 0.2);
      border: 1px solid rgba(black, 0.2);
      box-shadow: none !important;
      outline: none !important;
    }
  }
}
</style>
